/** @format */

import {
  CompareBarProduct,
  CompareProductDetails,
  ProductAvailabilityCollection,
} from '@shared/data-access/interfaces';
import { createAction, props } from '@ngrx/store';

export const setCompareBarProducts = createAction(
  '[Compare] Set the compare products',
  props<{ compareBarProducts: CompareBarProduct[] }>(),
);

export const compareBarProductsCleared = createAction('[Compare Bar] Products Cleared');

export const compareBarProductRemoved = createAction(
  '[Compare Bar] Product Removed',
  props<{ ecode: string }>(),
);

export const compareBarProductAdded = createAction(
  '[Compare Bar] Product Added',
  props<{ compareBarProduct: CompareBarProduct }>(),
);

export const compareDrawerOpened = createAction('[Compare] Drawer Opened');

export const compareDrawerClosed = createAction('[Compare] Drawer Closed');

export const compareProductsAvailabilityFetched = createAction(
  '[Compare] Products Availability Fetched',
  props<{ compareProductsAvailability: ProductAvailabilityCollection }>(),
);

export const compareProductDetailsFetchSucceeded = createAction(
  '[Compare] Product Details Fetch Succeeded',
  props<{ productDetails: CompareProductDetails }>(),
);

export const compareProductDetailsFetchFailed = createAction(
  '[Compare] Product Details Fetch Failed',
);

export const compareProductDetailsFetchTriggered = createAction(
  '[Compare] Product Details Fetch Triggered',
);

export const compareProductDetailsFetchRetryTriggered = createAction(
  '[Compare] Product Details Fetch Retry Triggered',
);
